<p-overlayPanel
    #op
    [style]="{ 'min-width': '200px', padding: '-20px', margin: '-20px' }"
>
    <ng-template pTemplate>
        <div class="conn-grid" style="margin-top: 1px">
            <div></div>
            <button
                pButton
                pRipple
                type="button"
                label="Edit"
                class="p-button-text"
                [style]="{ width: '100%' }"
                icon="pi pi-pencil"
                iconPos="right"
                (click)="optionEditClicked()"
            ></button>
            <button
                pButton
                pRipple
                type="button"
                label="Delete"
                class="p-button-danger p-button-text"
                icon="pi pi-trash"
                iconPos="right"
                (click)="deleteItem()"
            ></button>
            <!-- <button
                pButton
                pRipple
                type="button"
                label="Change Status"
                class="p-button-danger p-button-text"
                icon="pi pi-sort"
                iconPos="right"
                (click)="changeStatusClicked()"
            ></button> -->
        </div>
    </ng-template>
</p-overlayPanel>

<div class="conn-card">
    <app-report-top-filter-bar
        [paraReportName]="'category'"
        (filterCallbackFunc)="callbackFuncFromFilter($event)"
        (filterCallbackFuncUpdateFilter)="filterButtonPressed()"
        (exportExcelFn)="exportExcel()"
        (exportPdfFn)="exportPdf()"
        (deleteItemFn)="deleteMultipleItem()"
        (exportCsvFn)="dt.exportCSV()"
    >
    </app-report-top-filter-bar>

    <br />
    <p-table
        #dt
        [columns]="csvcols"
        styleClass="p-datatable-striped"
        [autoLayout]="true"
        [tableStyle]="{ width: 'max-content' }"
        [value]="dataList"
        responsiveLayout="scroll"
        showLoader="true"
        rowHover="true"
        selectionMode="single"
        [(selection)]="selectedRow"
        dataKey="id"
        (onRowSelect)="onRowSelect($event)"
        (onRowUnselect)="onRowUnselect($event)"
        (onRowSelect)="onRowSelect($event)"
        (onRowUnselect)="onRowUnselect($event)"
        [lazy]="true"
        (onLazyLoad)="customSort($event)"
    >
        <ng-template pTemplate="header">
            <tr>
                <th style="text-align: center; width: 30px">
                    <p-checkbox
                        [(ngModel)]="selectAll"
                        [binary]="true"
                        (onChange)="selectAllChanged($event)"
                    >
                    </p-checkbox>
                </th>
                <th pSortableColumn="categoryName">Category<p-sortIcon field="categoryName"></p-sortIcon></th>
                <th>Department</th>

                <th  class="text-center">Show on Online Store</th>

                <!-- <th style="text-align: center">Status</th> -->
                <th style="text-align: center">Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr [pSelectableRow]="item" class="text-center">
                <td style="text-align: center">
                    <p-checkbox
                        [(ngModel)]="item.selected"
                        [binary]="true"
                        (onChange)="selectionChanged($event)"
                    >
                    </p-checkbox>
                </td>
                <td>
                    <div
                        *ngIf="item.image"
                        class="conn-flex-image conn-flex-image-badge"
                        [style.background-image]="'url(' + item.image + ')'"
                    ></div>
                    <span
                        *ngIf="!item.image"
                        class="conn-flex-image-first-letter"
                    >
                        {{ item.categoryName | slice : 0 : 2 }}</span
                    >
                    {{ item.categoryName }}
                </td>

                <td>{{ item.departmentName }}</td>
                <td class="text-center">Yes</td>
                <td style="text-align: center">
                    <button
                        pButton
                        pRipple
                        icon="pi pi-angle-down"
                        iconPos="right"
                        type="button"
                        label="Actions"
                        class="n-action-button"
                        (click)="op.toggle($event)"
                        (click)="actionButtonClick(item)"
                    ></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" style="text-align: center">
            <tr>
                <td colspan="10" style="text-align: center">
                    There is no data to show.
                </td>
            </tr>
        </ng-template>
    </p-table>

    <p-paginator
        #p
        [first]="first"
        *ngIf="dataList?.length"
        (onPageChange)="onPageChange($event)"
        [rows]="rows"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[10, 25, 50, 100, 500, 1000]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Page: {currentPage} of {totalPages}, Total Records: {totalRecords}"
    ></p-paginator>
</div>

<p-dialog
    *ngIf="_categoryService.showNewEdit"
    header="Edit Category "
    [(visible)]="_categoryService.showNewEdit"
    modal="true"
>
    <app-new-edit-category [isNew]="false"
    [isEdit]="true"
    (refreshFn)="refreshFn($event)"></app-new-edit-category>
</p-dialog>

<p-dialog
    *ngIf="_categoryService.showNewNewEdit"
    header="New Category"
    [(visible)]="_categoryService.showNewNewEdit"
    [style]="{ width: '400px' }"
    modal="true"
>
    <app-new-edit-category
        [isNew]="true"
        (refreshFn)="refreshFn($event)"
    ></app-new-edit-category>
</p-dialog>
